import React, { useEffect } from 'react';

import { Form, Row, Col, Input, Table } from 'reactstrap';

import ReactButton from 'components/Buttons/ReactButton';

import { useForm, Controller } from 'react-hook-form';

import DatePickerIsValidCHA from 'views/CalendarScales/components/ChangeAvulsa/components/DatePickerIsValidCHA';
import FlexSelectCalenderCHA from 'views/CalendarScales/components/ChangeAvulsa/components/FlexSelectCalenderCHA';

import { toISOFormatAvulsa } from 'views/ChangeDayOff/functions';

import { format, addDays } from 'date-fns';

import UserService from '../../../User/service';

export default function AvulsaComponent({
  closeModal,
  setScaleSelected,
  scalesAvulsaTable,
  controlTable,
  daysOffObject,
  user,
  listFlexSelect,
  onSubmit,
  setControlTable,
  setScalesAvulsaTable,
  scales,
  isUndefined,
  isSupervisor
}) {
  const { control, handleSubmit, setValue, getValues, watch } = useForm();

  const [scalesAtendent, setScalesAtendent] = React.useState(scales);
  const [origemScaleId, setOrigemScaleId] = React.useState(
    user?.scale?.id ?? null
  );

  const atendenteOrigem = watch('supervisorShift');

  useEffect(() => {
    if (isSupervisor && atendenteOrigem) {
      UserService.get(atendenteOrigem)
        .then((res) => {
          if (res.data.data && res.data.data.scale && res.data.data.scale.id) {
            setScalesAtendent(
              scalesAtendent.filter(
                (scale) => scale.id !== res.data.data.scale.id
              )
            );
            setOrigemScaleId(res.data.data.scale.id);
          } else {
            setOrigemScaleId(null);
          }
        })
        .catch(() => setOrigemScaleId(null));
    } else {
      setOrigemScaleId(null);
    }
  }, [isSupervisor, atendenteOrigem]);

  const requestTableAvulsa = async () => {
    const tableTiein = getValues(['supervisorShift', 'dateTimeShift']);

    if (
      tableTiein.supervisorShift === '' ||
      tableTiein.supervisorShift === undefined
    ) {
      setControlTable(false);
    }
    if (
      tableTiein.dateTimeShift === '' ||
      tableTiein.dateTimeShift === undefined
    ) {
      setControlTable(false);
    }

    if (
      tableTiein.supervisorShift !== 'undefined' &&
      tableTiein.supervisorShift !== '' &&
      tableTiein.dateTimeShift !== 'undefined' &&
      tableTiein.dateTimeShift !== ''
    ) {
      const weekDay = format(
        addDays(new Date(toISOFormatAvulsa(tableTiein.dateTimeShift)), 1),
        'EEEE'
      );

      const lowerWeekDay = weekDay.toLowerCase();

      const newArray = scalesAtendent.map((item) => {
        if (
          item.sunday === true &&
          lowerWeekDay === 'sunday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.monday === true &&
          lowerWeekDay === 'monday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.tuesday === true &&
          lowerWeekDay === 'tuesday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.wednesday === true &&
          lowerWeekDay === 'wednesday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.thursday === true &&
          lowerWeekDay === 'thursday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.friday === true &&
          lowerWeekDay === 'friday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
        if (
          item.saturday === true &&
          lowerWeekDay === 'saturday' &&
          origemScaleId !== item.id
        ) {
          return item;
        }
      });
      const formatNewArray = newArray.filter(isUndefined);

      const dataScales = formatNewArray.map((item) => {
        const avulsaBeginDate = item[`beginTime${weekDay}`];
        const avulsaEndDate = item[`endTime${weekDay}`];
        const avulsaId = item.id;

        const objectTieinTable = {
          beginDate: avulsaBeginDate,
          endDate: avulsaEndDate,
          id: avulsaId,
          name: item.name
        };
        return objectTieinTable;
      });
      setScalesAvulsaTable(dataScales);
      setControlTable(true);
    }
  };
  return (
    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
      <Row className="mt-4 ml-1">
        <Col>
          <label className="form-control-label">
            {isSupervisor ? 'Atendente' : 'Supervisor'}
          </label>
          <Controller
            render={(props) => {
              return (
                <FlexSelectCalenderCHA
                  dataOptions={listFlexSelect}
                  isClearable={true}
                  isMulti={false}
                  value={props.value}
                  valueController={setValue}
                  fieldName="supervisorShift"
                  labelName="label"
                  valueName="value"
                  minWidth="192px"
                  requestTableAvulsa={requestTableAvulsa}
                />
              );
            }}
            control={control}
            name="supervisorShift"
            defaultValue=""
          />
        </Col>
        <Col>
          <label>Data de Troca</label>
          <Controller
            render={(props) => {
              return (
                <DatePickerIsValidCHA
                  fieldName="dateTimeShift"
                  valueController={setValue}
                  defaultValue={props.value}
                  requestTableAvulsa={requestTableAvulsa}
                  user={user}
                  daysOffObject={daysOffObject}
                />
              );
            }}
            control={control}
            name="dateTimeShift"
            defaultValue=""
          />
        </Col>
      </Row>
      {controlTable && (
        <Col className="mt-4">
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>Nome da escala</th>
                <th>Hora inicial</th>
                <th>Hora Final</th>
              </tr>
            </thead>
            <tbody>
              {scalesAvulsaTable.map((item, key) => {
                return (
                  <tr key={key}>
                    <th scope="row">
                      <Input
                        type="checkbox"
                        style={{
                          marginTop: '-0.5rem',
                          marginLeft: '0.5rem'
                        }}
                        onClick={() => {
                          setScaleSelected(item.id);
                        }}
                      />
                    </th>
                    <td>{item.name || ''}</td>
                    <td>{item.beginDate}</td>
                    <td>{item.endDate}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      )}

      <Row style={{ marginTop: '3rem', marginLeft: '9rem' }}>
        <ReactButton btnColor="confirmation" type="submit">
          Salvar
        </ReactButton>
        <ReactButton
          btnColor="cancelation"
          type="button"
          onClick={() => closeModal()}
        >
          Cancelar
        </ReactButton>
      </Row>
    </Form>
  );
}
